export default (state = [], action) => {
  switch (action.type) {
    case "FETCH_COMPARE_MARKETS":
        return action.payload;
    default:
      return state;
  }
};
